var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _g3, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 809,
    height: 451,
    viewBox: "0 0 809 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.042 35.2266C213.433 31.3712 218.581 30.4194 222.274 33.0547L309.248 95.1299C311.691 96.8736 312.952 99.8383 312.515 102.808L309.673 122.096L388.173 71.8477C390.887 70.1102 394.379 70.1708 397.031 72.002L521.726 158.1C523.914 159.61 525.113 162.013 525.178 164.478L567.999 104.481C570.566 100.886 575.561 100.051 579.157 102.617L663.85 163.064C667.446 165.631 668.281 170.627 665.714 174.224L543.96 344.814C541.393 348.411 536.397 349.244 532.801 346.678L448.108 286.231C445.983 284.714 444.822 282.348 444.758 279.924L401.978 339.865C399.424 343.443 394.462 344.29 390.865 341.763L287.968 269.436L287.347 273.653C286.702 278.031 282.48 281.043 278.125 280.26C120.007 251.805 164.687 109.985 211.042 35.2266Z",
    fill: "url(#paint0_linear_2152_20358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M554.969 122.735L652.684 192.476L632.343 220.976L534.628 151.234L554.969 122.735Z",
    fill: "#181C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.688 129.171C262.688 142.426 251.942 153.171 238.688 153.171C225.433 153.171 214.688 142.426 214.688 129.171C214.688 115.917 225.433 105.171 238.688 105.171C251.942 105.171 262.688 115.917 262.688 129.171Z",
    fill: "#181C24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M463.207 174.19C463.207 187.445 452.462 198.19 439.207 198.19C425.952 198.19 415.207 187.445 415.207 174.19C415.207 160.936 425.952 150.19 439.207 150.19C452.462 150.19 463.207 160.936 463.207 174.19Z",
    fill: "#181C24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M413.619 132.517C413.619 145.772 402.874 156.517 389.619 156.517C376.364 156.517 365.619 145.772 365.619 132.517C365.619 119.262 376.364 108.517 389.619 108.517C402.874 108.517 413.619 119.262 413.619 132.517Z",
    fill: "#181C24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M473.306 197.287C465.651 208.107 468.216 223.085 479.037 230.741L506.76 191.557C495.94 183.901 480.962 186.467 473.306 197.287Z",
    fill: "#181C24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2152_20358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.832 276.065L100.832 210.337L700.292 210.337L700.292 276.065L100.832 276.065Z",
    fill: "#181C24",
    fillOpacity: 0.6
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.652 226.186C127.363 216.554 140.074 206.922 152.785 209.503C165.496 212.084 178.208 226.878 190.919 226.186C203.63 225.495 216.341 209.318 229.052 209.503C241.763 209.688 254.474 226.236 267.185 226.186C279.896 226.137 292.608 209.49 305.319 209.503C318.03 209.516 330.741 226.19 343.452 226.186C356.163 226.183 368.874 209.502 381.585 209.503C394.296 209.504 407.008 226.186 419.719 226.186C432.43 226.187 445.141 209.506 457.852 209.503C470.563 209.5 483.274 226.173 495.985 226.186C508.696 226.2 521.408 209.553 534.119 209.503C546.83 209.453 559.541 226.001 572.252 226.186C584.963 226.372 597.674 210.195 610.385 209.503C623.096 208.811 635.808 223.605 648.519 226.186C661.23 228.767 673.941 219.135 686.652 209.503V371.57C673.941 371.57 661.23 371.57 648.519 371.57C635.808 371.57 623.096 371.57 610.385 371.57C597.674 371.57 584.963 371.57 572.252 371.57C559.541 371.57 546.83 371.57 534.119 371.57C521.408 371.57 508.696 371.57 495.985 371.57C483.274 371.57 470.563 371.57 457.852 371.57C445.141 371.57 432.43 371.57 419.719 371.57C407.008 371.57 394.296 371.57 381.585 371.57C368.874 371.57 356.163 371.57 343.452 371.57C330.741 371.57 318.03 371.57 305.319 371.57C292.608 371.57 279.896 371.57 267.185 371.57C254.474 371.57 241.763 371.57 229.052 371.57C216.341 371.57 203.63 371.57 190.919 371.57C178.208 371.57 165.496 371.57 152.785 371.57C140.074 371.57 127.363 371.57 114.652 371.57V226.186Z",
    fill: "url(#paint1_linear_2152_20358)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M238.774 1.4537C239.819 0.168822 241.709 -0.025473 242.994 1.02011C244.279 2.06592 244.474 3.95582 243.428 5.24081L218.443 35.9381L218.342 36.0553C217.279 37.2339 215.467 37.3838 214.222 36.3707C212.937 35.3248 212.742 33.435 213.788 32.15L238.774 1.4537Z",
    fill: "#6B7587"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.897 18.4796C259.943 17.1947 261.832 17.0004 263.117 18.046C264.402 19.0918 264.597 20.9817 263.551 22.2667L238.566 52.964L238.465 53.0811C237.402 54.2598 235.59 54.4097 234.345 53.3966C233.06 52.3507 232.866 50.4609 233.911 49.1759L258.897 18.4796Z",
    fill: "url(#paint2_linear_2152_20358)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M279.018 35.5055C280.064 34.2206 281.954 34.0263 283.239 35.0719C284.523 36.1177 284.718 38.0076 283.672 39.2926L258.687 69.9898L258.586 70.107C257.523 71.2857 255.711 71.4356 254.466 70.4225C253.181 69.3766 252.987 67.4868 254.032 66.2017L279.018 35.5055Z",
    fill: "url(#paint3_linear_2152_20358)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M299.139 52.5313C300.185 51.2465 302.075 51.0522 303.36 52.0977C304.644 53.1436 304.839 55.0335 303.793 56.3184L278.808 87.0157L278.707 87.1329C277.644 88.3116 275.832 88.4615 274.587 87.4483C273.302 86.4024 273.108 84.5126 274.154 83.2276L299.139 52.5313Z",
    fill: "url(#paint4_linear_2152_20358)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M233.875 7.78207C234.863 6.51774 236.664 6.26094 237.962 7.17367L238.086 7.26644L300.013 55.6639C301.318 56.6842 301.548 58.5694 300.528 59.8748C299.508 61.1802 297.623 61.4117 296.317 60.3914L234.391 11.993L234.271 11.8954C233.072 10.8559 232.887 9.0467 233.875 7.78207Z",
    fill: "#6B7587"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M631.344 29.2129L653.695 43.9598L637.174 69.0006L614.822 54.2537L631.344 29.2129Z",
    fill: "#717B8E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M645.992 89.2427L668.343 103.99L651.822 129.03L629.471 114.283L645.992 89.2427Z",
    fill: "#717B8E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2152_20358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.832 177.695H768.292V370.44H654.832V177.695Z",
    fill: "#181C24"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2152_20358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8301 156.517H154.29V410.79H40.8301V156.517Z",
    fill: "#181C24"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M462.691 316.909C446.838 316.909 436.797 303.786 436.797 284.674C436.797 265.561 446.838 252.438 462.691 252.438C478.457 252.438 488.497 265.561 488.497 284.674C488.497 303.786 478.457 316.909 462.691 316.909ZM462.691 262.479C453.355 262.479 447.718 271.374 447.718 284.674C447.718 297.973 453.355 306.869 462.691 306.869C471.939 306.869 477.576 297.973 477.576 284.674C477.576 271.374 471.939 262.479 462.691 262.479Z",
    fill: "#181C24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M401.107 316.909C385.254 316.909 375.213 303.786 375.213 284.674C375.213 265.561 385.254 252.438 401.107 252.438C416.873 252.438 426.913 265.561 426.913 284.674C426.913 303.786 416.873 316.909 401.107 316.909ZM401.107 262.479C391.771 262.479 386.134 271.374 386.134 284.674C386.134 297.973 391.771 306.869 401.107 306.869C410.355 306.869 415.992 297.973 415.992 284.674C415.992 271.374 410.355 262.479 401.107 262.479Z",
    fill: "#181C24"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M343.082 316.909C332.777 316.909 324.851 312.065 320.623 302.729L330.135 298.149C332.601 304.05 336.829 307.045 342.994 307.045C350.569 307.045 355.501 302.465 355.501 295.067C355.501 287.932 350.921 283.441 343.523 283.441C338.679 283.441 335.244 285.378 332.777 289.166L323.618 287.052L325.203 253.847H362.635V263.447H334.099L333.394 278.773C336.741 275.778 340.792 274.369 345.813 274.369C357.967 274.369 366.07 282.472 366.07 294.979C366.07 308.366 356.734 316.909 343.082 316.909Z",
    fill: "#181C24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2152_20358",
    x: 60.832,
    y: 170.337,
    width: 679.461,
    height: 145.728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2152_20358"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2152_20358",
    x: 614.832,
    y: 137.695,
    width: 193.461,
    height: 272.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2152_20358"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2152_20358",
    x: 0.830078,
    y: 116.517,
    width: 193.459,
    height: 334.272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2152_20358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2152_20358",
    x1: 424.566,
    y1: 88.5997,
    x2: 336.484,
    y2: 347.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2152_20358",
    x1: 434.871,
    y1: 194.034,
    x2: 432.481,
    y2: 359.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2152_20358",
    x1: 248.731,
    y1: 20.3731,
    x2: 248.731,
    y2: 51.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B7587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B7486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2152_20358",
    x1: 268.852,
    y1: 37.399,
    x2: 268.852,
    y2: 68.0958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B7587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#677082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2152_20358",
    x1: 288.973,
    y1: 54.4249,
    x2: 288.973,
    y2: 85.1217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B7587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646D7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.2c7a62a1f88cfa312149cd6c12ad7874.svg";
export { ForwardRef as ReactComponent };